import React from 'react';
import { connect } from "react-redux";
import { Form, Input, Tabs, DatePicker, Radio, message, Upload, Button, Checkbox, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { getLangList } from "@/lib/i18n";
import { showDelConfirm, modalFromLayout } from "@/lib/antdElementFunction";
import User from "@/config/user";
import { clearUserinfo } from "@/stores/user/action";
import { avatarUploadProps, normFile, convertBase64ToPicture } from "@/lib/uploadFunction";
import { getStorage } from "@/lib/webStorage";

const { deleteUserAccountDetail } = User;
const { TabPane } = Tabs;

interface props {
  dispatch: any;
  user: any;
  getUserInfo?: any;
  form: any;
  handleType: string;
}

interface state {
  panes: Array<object>;
  activeKey: string;
  [key: string]: any;
}

class ModalProfile extends React.Component<props, state> {
  state = {
    panes: [],
    activeKey: '0',
  };
  buttonT: any = getLangList("button");
  errorT: any = getLangList("error");
  profileInfoT: any = getLangList("profileInfo");
  tabIndex: number = -1;

  componentDidMount() {
    const { handleType } = this.props;
    if (handleType === 'updateProfileInfoDidMomunt') {
      this.initFormData();
    }
  }

  componentDidUpdate(prevProps: any) {
    const { user } = this.props;
    const { userInfo } = user;
    const prevPropsUserInfo = prevProps?.user?.userInfo ?? {};

    if (JSON.stringify(userInfo) !== JSON.stringify(prevPropsUserInfo)) {
      this.initFormData();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearUserinfo());
  }

  initFormData = () => {
    const { form, user } = this.props;
    const { userInfo } = user;
    const {
      nameCn = '',
      nameEn = '',
      accessCardNumber,
      birthday,
      gender = '',
      residenceAddress = '',
      mailingAddress = '',
      identityNumber = '',
      school = '',
      grade = '',
      classroom = '',
      seatNumber = '',
      allergy = '',
      isLunch = false,
      isSnack = false,
      details = [],
    } = userInfo;

    form.setFieldsValue({
      nameCn,
      nameEn,
      accessCardNumber,
      birthday: birthday ? moment(birthday) : undefined,
      gender,
      residenceAddress,
      mailingAddress,
      identityNumber,
      school,
      grade,
      classroom,
      seatNumber,
      allergy,
      isLunch,
      isSnack,
    });
    details.forEach((item: any, index: number) => {
      item.key = `${index}`;
      form.setFieldsValue({
        [`name_${index}`]: item.name,
        [`relationship_${index}`]: item.relationship,
        [`homePhone_${index}`]: item.homePhone,
        [`officePhone_${index}`]: item.officePhone,
        [`cellphone_${index}`]: item.cellphone,
        [`email_${index}`]: item.email,
        [`userAccountDetailId_${index}`]: item.userAccountDetailId,
        tabIndex: ++this.tabIndex,
      });
    });
    this.setState({ panes: details });
  }

  addTab = () => {
    const { form } = this.props;
    const { panes } = this.state;
    const activeKey = `${++this.tabIndex}`;
    const newPanes: any = [...panes];

    form.setFieldsValue({
      [`name_${this.tabIndex}`]: '',
      [`relationship_${this.tabIndex}`]: 'relationship',
      [`homePhone_${this.tabIndex}`]: '',
      [`officePhone_${this.tabIndex}`]: '',
      [`cellphone_${this.tabIndex}`]: '',
      [`email_${this.tabIndex}`]: '',
      tabIndex: this.tabIndex,
    });
    newPanes.push({ relationship: 'relationship', key: activeKey });
    this.setState({
      panes: newPanes,
      activeKey,
    });
  };

  removeTab = (targetKey: string) => {
    showDelConfirm(() => this.deleteUserAccountDetail(targetKey), this.buttonT.confirm_delete);
  };

  onEdit = (targetKey: any, action: any) => {
    action === 'add' && this.addTab();
    action === 'remove' && showDelConfirm(() => this.deleteUserAccountDetail(targetKey), this.buttonT.confirm_delete);
  };

  renderParent = () => {
    const { panes } = this.state;
    const { handleType } = this.props;
    const isViewProfileInfo = handleType === 'viewProfileInfo';

    return panes.map((item: any, index: number) => {
      const { relationship = '' } = item;

      return (
        <TabPane
          tab={relationship}
          key={`${index}`}
          closable={(index === (this.tabIndex)) && (index !== 0) && !isViewProfileInfo}
          forceRender
        >
          <Form.Item label={this.profileInfoT.NAME} name={`name_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item label={this.profileInfoT.RELATIONSHIP} name={`relationship_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item label={this.profileInfoT.HONE_PHONE} name={`homePhone_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item label={this.profileInfoT.OFFICE_PHONE} name={`officePhone_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item label={this.profileInfoT.CELLPHONE} name={`cellphone_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item label={this.profileInfoT.EMAIL} name={`email_${index}`}>
            <Input {...this.inputProps()} />
          </Form.Item>
          <Form.Item style={{ display: 'none' }} name={`userAccountDetailId_${index}`}>
            <Input />
          </Form.Item>
        </TabPane>
      );
    });
  };

  deleteUserAccountDetail = (targetKey: string) => {
    const { panes } = this.state;
    const { form, getUserInfo } = this.props;
    const newPanes = panes.filter((item: any) => item.key !== targetKey);
    const userAccountDetailId = form.getFieldValue(`userAccountDetailId_${targetKey}`);

    if (userAccountDetailId) {
      deleteUserAccountDetail(userAccountDetailId).then((res: any) => {
        if (!res.success) {
          return message.error(this.errorT.failed);
        }
        getUserInfo();
      });
    }
    form.setFieldsValue({ tabIndex: --this.tabIndex });
    this.setState({
      panes: newPanes,
      activeKey: '0',
    });
  }

  inputProps = () => {
    const { handleType } = this.props;
    const isViewProfileInfo = handleType === 'viewProfileInfo';
    return isViewProfileInfo ? { disabled: true, bordered: false } : {};
  }

  render() {
    const { activeKey } = this.state;
    const { form, handleType, user } = this.props;
    const { userInfo } = user;
    const { idCard, qrCode } = userInfo;
    const isCreateUser = handleType === 'createUser';
    const isViewProfileInfo = handleType === 'viewProfileInfo';
    const roleId = +getStorage("roleId");

    return (
      <Form {...modalFromLayout} form={form} className='modal-profile'>
        {isCreateUser &&
          <Form.Item label={this.profileInfoT.ACCOUNT} name="username" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        }

        {isCreateUser &&
          <Form.Item label={this.profileInfoT.PASSWORD} name="password" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
        }

        <Form.Item label={this.profileInfoT.NAME_CN} name="nameCn" rules={[{ required: true }]}>
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.NAME_EN} name="nameEn" rules={[{ required: true }]}>
          <Input {...this.inputProps()} />
        </Form.Item>

        {isCreateUser &&
          <Form.Item label={this.profileInfoT.SITE_NO} name="cramClassSeatNum" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        }

        {!isViewProfileInfo &&
          <Form.Item
            label={this.profileInfoT.AVATAR}
            name="idCardImg"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            tooltip={idCard ?
              <Row justify="center">
                <Col>Previous:</Col>
                <Col><img height="200px" width="200px" alt="avatar" src={convertBase64ToPicture(idCard)} /></Col>
              </Row> : null
            }
          >
            <Upload {...avatarUploadProps}>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
        }

        {!isViewProfileInfo &&
          <Form.Item
            label={this.profileInfoT.QRCODE}
            name="qrCode"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            tooltip={qrCode ?
              <Row justify="center">
                <Col>Previous:</Col>
                <Col><img height="200px" width="200px" alt="avatar" src={convertBase64ToPicture(qrCode)} /></Col>
              </Row> : null
            }
          >
            <Upload {...avatarUploadProps}>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
        }

        <Form.Item label={this.profileInfoT.ACCESS_CARD_NUMBER} name="accessCardNumber">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.BIRTHDAY} name="birthday">
          <DatePicker allowClear={false} {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.GENDER} name="gender" rules={[{ required: true }]}>
          <Radio.Group {...this.inputProps()}>
            <Radio value="male">{this.profileInfoT.MALE}</Radio>
            <Radio value="female">{this.profileInfoT.FEMALE}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label={this.profileInfoT.RESIDENCE_ADDRESS} name="residenceAddress">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.MAILING_ADDRESS} name="mailingAddress">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.IDENTITY_NUMBER} name="identityNumber">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.SCHOOL} name="school">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.GRADE} name="grade">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.SCHOOL_CLASSROOM} name="classroom">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.SCHOOL_SITE_NO} name="seatNumber">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.IS_LUNCH} name="isLunch" valuePropName='checked'>
          <Checkbox disabled={roleId === 2 || isViewProfileInfo} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.IS_SNACK} name="isSnack" valuePropName='checked'>
          <Checkbox disabled={roleId === 2  || isViewProfileInfo} />
        </Form.Item>

        <Form.Item label={this.profileInfoT.ALLERGY} name="allergy">
          <Input {...this.inputProps()} />
        </Form.Item>

        <Form.Item style={{ display: 'none' }} name="tabIndex">
          <Input />
        </Form.Item>

        <Tabs
          defaultActiveKey="0"
          type="editable-card"
          onEdit={this.onEdit}
          onChange={(activeKey: string) => this.setState({ activeKey })}
          activeKey={activeKey}
          hideAdd={isViewProfileInfo}
          addIcon={<span>+ {this.profileInfoT.CONTACT}</span>}
        >
          {this.renderParent()}
        </Tabs>
      </Form>
    );
  }
}

function mapStateToProps(state: any) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps)(ModalProfile);